export const ADD_ON_UPGRADE_PAGE = 'AddonUpgradePage';
export const UPGRADE_PAGE_APP = 'UpgradePageApp';
export const COMPARE_PRO_FEATURE_TABLE = 'CompareProFeatureTable';
export const WHY_GO_HUBSPOT_SECTION = 'WhyGoHubSpotSection';
export const COMPARE_PLANS_LINK = 'ComparePlansLink';
export const HUB_PRO_PLUS_UPGRADE_PAGE = 'HubProPlusUpgradePage';
export const HUB_STARTER_UPGRADE_PAGE = 'HubStarterUpgradePage';
export const SUITE_STARTER_UPGRADE_PAGE = 'SuiteStarterUpgradePage';
export const MC651_SUITE_STARTER_FEATURE_TABLE_CONTAINER = 'MC651SuiteStarterFeatureTableContainer';
export const SUITE_STARTER_FEATURE_TABLE_CONTAINER = 'SuiteStarterFeatureTableContainer';
export const FEATURE_INTEREST_AND_LIMIT_USAGE_SECTION = 'FeatureInterestAndLimitUsageSection';
export const UPGRADE_CONFIG_CONTENT_GENERIC_SUITE_STARTER = 'UpgradeConfigContentGenericSuiteStarter';
export const TRIAL_UPGRADE_PAGE = 'TrialUpgradePage';
export const TRIAL_UPGRADE_PAGE_CONTAINER = 'TrialUpgradePageContainer';
export const COMPARE_TRIAL_PLAN_TABLE = 'CompareTrialPlanTable';
export const TRIAL_UPGRADE_NAV_BANNER = 'TrialUpgradeNavBanner';
export const TRIAL_UPGRADE_HERO_BANNER = 'TrialUpgradeHeroBanner';
export const TRIAL_UPGRADE_DAYS_REMAINING_HEADER = 'TrialUpgradeDaysRemainingHeader';
export const TRIAL_UPGRADE_FEATURE_PANELS = 'TrialUpgradeFeaturePanels';
export const PRO_PLUS_PAGE_CONDITIONAL_WRAPPER = 'ProPlusPageConditionalWrapper';
export const HC0124_HUB_PRO_PLUS_UPGRADE_PAGE = 'HC0124HubProPlusUpgradePage';
export const HC0124_UPGRADE_HERO_BANNER = 'HC0124UpgradeHeroBanner';
export const HC0124_COMPARE_PRO_FEATURE_TABLE = 'HC0124CompareProFeatureTable';
export const FREE_SUITE_STARTER_FEATURE_TABLE_CONTAINER = 'FreeSuiteStarterFeatureTableContainer';
export const POPULAR_FEATURES_PANEL = 'PopularFeaturesPanel';
export const MC0655_LIMIT_USAGE_SECTION = 'MC0655LimitUsageSection';